import { c as _c } from "react/compiler-runtime";
import type { RuleAction, RuleSetResult } from '@onefootprint/request-types/dashboard';
import ErrorComponent from '@/components/error';
import groupRuleResults from '@/entities/components/details/utils/group-rule-results';
import Content from './components/content';
import Loading from './components/loading';
export type RuleSetResultsProps = {
  data?: RuleSetResult;
  isLoading?: boolean;
  error?: Error | null;
};
const RuleSetResults = t0 => {
  const $ = _c(10);
  const {
    data,
    isLoading,
    error
  } = t0;
  let t1;
  if ($[0] !== isLoading) {
    t1 = isLoading && <Loading />;
    $[0] = isLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== error) {
    t2 = error && <ErrorComponent error={error} />;
    $[2] = error;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data) {
    t3 = data && data.ruleResults.length > 0 && <Content actionTriggered={data.actionTriggered as RuleAction} ruleResults={groupRuleResults(data.ruleResults)} />;
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default RuleSetResults;